import sanitizeHtml from 'sanitize-html';

export const sanitizeResponsibilityHtml = (responsibilities) => {
  const sanitizedResponsibilities = {};
  sanitizeHtml(responsibilities, {
    allowedTags: ['li'],
    textFilter: (text) => (text.replaceAll(/&amp;/g, '&')),
  }).replaceAll(/<li>/g, '')
    .split('</li>')
    .forEach((v, i) => {
      sanitizedResponsibilities[i] = { description: v };
    });

  return sanitizedResponsibilities;
};

export const responsibilitiesToListElements = (responsibilities) => responsibilities.map((res) => `<li>${res.description}</li>`).join('');

export const sanitizeOnChangeValue = (responsibilities) => sanitizeHtml(responsibilities, {
  allowedTags: ['li'],
});

export const listElementsToArray = (idealCandidate) => {
  if (!idealCandidate) return [];

  return idealCandidate.replaceAll(/<li>/g, '').replaceAll(/&amp;/g, '&').split('</li>').filter(Boolean);
};

export const formatIdealCandidateOnLoad = (idealCandidate) => {
  if (!idealCandidate) return null;
  if (!idealCandidate.includes('<li>')) return `<li>${idealCandidate}</li>`;

  return idealCandidate;
};

export const decodeAmpersands = (inputText) => inputText.replaceAll(/&amp;(?:amp;)?/g, '&');
